import { Types } from './ReportContext'

const ModalReducer = (state: any, action: any) => {
  const { payload, type } = action;

  switch (type) {
    case Types.CREATE_REPORTS:
      return {
        ...state,
        createModalReports: true
      }
    case Types.EDIT_REPORTS:
      return {
        ...state,
        _id: payload._id,
        editModalReports: true
      }
    case Types.FIND_DATE_REPORTS:
      return {
        ...state,
        _id: payload._id,
        findModalReports: true
      }
    case Types.DELETE_REPORTS:
      return {
        ...state,
        _id: payload._id,
        deleteModalReports: true,
        report: payload.report
      }
    case Types.CLEAR_REPORTS:
      return {
        ...state,
        _id: '',
        createModalReports: payload.createModalReports,
        editModalReports: payload.editModalReports,
        findModalReports: payload.findModalReports,
        deleteModalReports: payload.deleteModalReports,
        createModalGraph: payload.createModalGraph,
        report: null
      }
    case Types.CLOSE_CREATE_REPORTS:
      return {
        ...state,
        createModalReports: false
      }
    case Types.PREVIEW_DATA:
      return {
        ...state,
        previewData: payload
      } 
    case Types.CREATE_GRAPH:
      return {
        ...state,
        createModalGraph: true
      }
     case Types.LOAD_DATA_REPORT:
      return {
        ...state,
        reportPreviewData: {
          ...action.payload,
          columnasVisibles: action.payload.columnas || Object.keys(action.payload.report?.[0] || []),
          agrupadorSeleccionado: null, 
          
        },
      };
   case Types.UPDATE_VISIBLE_COLUMNS:
      return {
        ...state,
        reportPreviewData: {
          ...state.reportPreviewData,
          columnasVisibles: action.payload,
        },
      };

    case Types.UPDATE_SELECTED_GROUP:
      return {
        ...state,
        reportPreviewData: {
          ...state.reportPreviewData,
          agrupadorSeleccionado: action.payload,
        },
      };
    case Types.INPUT_VALUES:
        const prevValues = state.reportPreviewData.inpuntValues || [];        
        const updatedObject = {
          ...(prevValues[0] || {}),
          ...action.payload,
        };
        return {
          ...state,
          reportPreviewData: {
            ...state.reportPreviewData,
            inpuntValues: [updatedObject],
          },
      };
      case Types.UPDATE_REPORT_DATA:
        return {
          ...state,
          reportPreviewData: {
          ...state.reportPreviewData,
          report: action.payload,
        },
      };
      
    default:
      return state;
  }
}

export default ModalReducer;